// deps
// eslint-disable-next-line import/no-unresolved
import Router from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router";
// eslint-disable-next-line import/no-unresolved
import Uri from "@splitfire-agency/raiden-library/dist/libraries/Uri";

export const frontBaseUri = new Uri(
  // @ts-ignore
  process.env.NEXT_PUBLIC_FRONT_SCHEME,
  null,
  process.env.NEXT_PUBLIC_FRONT_HOST,
  null,
  null,
  null,
  null,
);

export const frontBaseUriWithBasePath = new Uri(
  // @ts-ignore
  process.env.NEXT_PUBLIC_FRONT_SCHEME,
  null,
  process.env.NEXT_PUBLIC_FRONT_HOST,
  null,
  process.env.NEXT_PUBLIC_FRONT_BASE_PATH,
  null,
  null,
);

/**
 * Build a router.
 * @param {import ("@splitfire-agency/raiden-library/dist/libraries/Uri").default} baseUri
 * @return {import ("@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router").default})}
 */
function buildRouter(baseUri) {
  const frontRouter = new Router();

  frontRouter.group(baseUri, (frontRouter) => {
    // assets (previewer)
    frontRouter
      .get("/public/<filePath>")
      .setId("@front.assets")
      .setConstraint("filePath", /.*/);

    // internal assets (nextjs)
    frontRouter
      .get("/<filePath>")
      .setId("@front.internal-assets")
      .setConstraint("filePath", /.*/);

    frontRouter.group("/<locale>", (frontRouter) => {
      frontRouter.get("/").setId("@front.home");
      // articles
      frontRouter.get("/actualites").setId("@front.articles");
      frontRouter.get("/actualites/<postSlug>").setId("@front.article");
      // events
      frontRouter.get("/agenda").setId("@front.events");
      frontRouter.get("/agenda/<postSlug>").setId("@front.event");
      // associations
      frontRouter.get("/associations").setId("@front.associations");
      frontRouter.get("/associations/<postSlug>").setId("@front.association");
      // ---
      frontRouter.get("/pages/<postSlug>").setId("@front.page");
      frontRouter.get("/contact").setId("@front.contact");
      frontRouter.get("/salles-communales").setId("@front.communityHalls");
    });

    frontRouter.group("/api", (frontRouter) => {
      frontRouter
        .get("/translation-messages")
        .setId("@front.api.translation-messages");
    });
  });

  return frontRouter;
}

export const frontRouter = buildRouter(frontBaseUri);
export const frontRouterWithBasePath = buildRouter(frontBaseUriWithBasePath);
